import { useState } from 'react';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import { TopicModal } from '../../Molecules';

// footnoteIndex: { [uuid]: number } — authoritative numbering computed
// server-side (see decision-log-footnotes.md, Option A1). This component
// never derives numbers itself; it only looks them up.
const RawHtml = ({ html = '', className = '', footnoteIndex = {} }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [activeTopic, setActiveTopic] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const handleTopicClick = async (href, topicId) => {
    setIsLoading(true);
    setIsModalOpen(true);
    try {
      const res = await fetch(`/wt/api/nextjs/v1/page_by_path/?html_path=${href}`);
      const data = await res.json();
      const props = data.component_props;
      setActiveTopic({
        title: props.title,
        summary: props.summary,
        url: href,
        id: topicId,
      });
    } catch (e) {
      setActiveTopic(null);
    } finally {
      setIsLoading(false);
    }
  };
  const options = {
    replace(domNode) {
      if (
        domNode.name === 'a' &&
        domNode.attribs?.['data-topic-page'] === '1'
      ) {
        const href = domNode.attribs.href;
        const topicId = domNode.attribs['data-topic-id'];
        return (
          <button
            type="button"
            className="topic-link"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleTopicClick(href, topicId);
            }}
          >
            {domToReact(domNode.children, options)}
          </button>
        );
      }

      if (domNode.name === 'footnote') {
        const uuid = domNode.attribs?.id;
        const number = uuid ? footnoteIndex[uuid] : undefined;

        // No match (e.g. stale uuid, or footnoteIndex not passed) — drop
        // the tag rather than render an unstyled/broken marker.
        if (!uuid || number === undefined) return null;

        return (
          <sup className="footnote-marker">
            <a
              id={`footnote-ref-${uuid}`}
              href={`#footnote-${uuid}`}
              aria-label={`Jump to footnote ${number}`}
            >
              {number}
            </a>
          </sup>
        );
      }
    },
  };
  return (
    <>
      <div className={`rich-content ${className}`}>
        {parse(html, options)}
      </div>
      <TopicModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        topic={
          isLoading
            ? { title: '...', summary: null, url: null }
            : activeTopic
        }
      />
    </>
  );
};
RawHtml.propTypes = {
  html: PropTypes.string.isRequired,
  className: PropTypes.string,
  footnoteIndex: PropTypes.object,
};
export default RawHtml;